import { Label, SelectReg } from "@britishcouncil/react-registration-platform"
import { useEffect, useState } from "react";

interface Options {
    value: string;
    label: string;
}

interface Props {
    name: string
    id: string
    label?: string
    helpText?: string
    options: Options[]
    required?: boolean
    defaultValue?: string | number;
    onChange: (options: any) => void
}

export function DefaultSelect({ name, options, label, helpText, id, required, defaultValue, onChange }: Readonly<Props>) {

    const [value, setValue] = useState<Options>();

    const onValueChange = (val: Options) => {
        setValue(val)
        onChange(val)
    }

    useEffect(() => {
        const option = options.find(item => item.value === defaultValue)
        if(option && !value){
            setValue(option)
        }
    }, [defaultValue, options])

    return <div>
        {label ? (
            <Label placeholder="" helpText={helpText} htmlFor={name}>
                {label}
            </Label>
        ) : null}
        <SelectReg
            data-testid={id}
            name={name}
            value={value}
            required={required}
            onChange={(val) => onValueChange(val as Options)}
            options={options}
        />
    </div>
}